const ageRanges = [
    "Menos de 21",
    "21 a 30",
    "31 a 40",
    "41 a 50",
    "51 a 60",
    "Más de 60",
  ];
  
  export default ageRanges;
  